// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ea19ac3a","488":"2de88e0b","732":"b173debf"}[chunkId] + ".chunk.js";
};